import styled from "styled-components"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
   background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
   margin-top: 100px;
   padding: 20px;
   min-height: 85vh;
   display: flex;
   flex-direction: column;
   align-items: center;

   ${tablet({ marginTop: "80px" })}
   ${mobile({ marginTop: "60px", padding: "10px" })}
    ${mobilePortrait({ marginTop: "40px" })}
`

export const Header = styled.div`
   border: 1.5px solid var(--secondary);
   border-radius: 10px;
   margin-top: 20px;
   padding: 20px;
   width: 90vw;
`

export const Title = styled.h1`
   font-weight: 200;
   margin-bottom: 20px;
`

export const Form = styled.form``

export const StyledInputs = styled.div`
   display: flex;
   flex-wrap: wrap;
`

export const FormItem = styled.div`
   width: 400px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   margin-bottom: 15px;
   margin-right: 20px;

   ${tablet({ width: "300px" })}
   ${mobile({ width: "250px" })}
`

export const StyledLabel = styled.label`
   margin-bottom: 5px;
`

export const StyledInput = styled.input`
   background-color: ${({ theme }) => theme.body};
   color: ${({ theme }) => theme.text};
   font-size: var(--fontS);
   border: none;
   border-bottom: 1px solid var(--primary);
   border-radius: 5px;
   height: 30px;

   ::placeholder {
      color: ${({ theme }) => theme.text};
   }

   :focus {
      border-bottom: 1px solid var(--secondary);
      outline: none;
   }
`

export const StyledTextArea = styled.textarea`
   width: 400px;
   background-color: ${({ theme }) => theme.body};
   color: ${({ theme }) => theme.text};
   border: 1px solid var(--primary);
   border-radius: 5px;
   height: 100px;

   ::placeholder {
      color: ${({ theme }) => theme.text};
   }

   :focus {
      border: 1px solid var(--secondary);
      outline: none;
   }

   ${tablet({ width: "300px" })}
   ${mobile({ width: "250px" })}
`

export const Message = styled.div`
   margin-top: 20px;
   color: var(--secondary);
`

export const Upload = styled.div`
   margin: 10px 0px;
   display: flex;
   align-items: center;
`

export const UpdateImage = styled.img`
   width: 80px;
   height: 80px;
   border-radius: 10px;
   object-fit: cover;
   margin-right: 20px;
   background-color: var(--medGrey);
`

export const UploadIcon = styled.div`
   cursor: pointer;
   color: var(--secondary);
`

export const StyledButton = styled.button`
   width: 100px;
   border: none;
   padding: 5px;
   background-color: var(--primary);
   border-radius: 5px;
   color: var(--white);
   font-size: var(--fontM);
   cursor: pointer;
`

export const CheckboxGroup = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 10px;
   margin: 1em 0;
`

export const RadioLabel = styled.label`
   font-size: var(--fontM);
   line-height: 1.1;
   display: grid;
   grid-template-columns: 1em auto;
   gap: 0.5em;
   margin-top: 0.5em;

   :focus-within {
      color: var(--secondary);
   }

   ${mobile({ marginTop: "0.25em" })}
`

export const RadioInput = styled.input`
   appearance: none;
   font: inherit;
   color: var(--secondary);
   width: 1.15em;
   height: 1.15em;
   border: 0.15em solid currentColor;
   border-radius: 50%;
   transform: translateY(-0.075em);
   display: grid;
   place-content: center;

   ::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      border-radius: 50%;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--secondary);
   }

   :checked::before {
      transform: scale(1);
   }
`

export const FilteredList = styled.div`
   margin-top: 10px;
`

export const FilteredValue = styled.div`
   font-size: var(--fontS);
   cursor: pointer;
   padding: 5px 5px;
`
